(function(QueryParams, $, undefined) {

  QueryParams.init = function() {
    window.queryParams = parseURL(window.location).searchObject
  }

}(window.QueryParams = window.QueryParams || {}, jQuery));